const s = {
  name: "Code",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,2H0V0h35V2z"/>
		<path class="st0" d="M40,38H5v-2h35V38z"/>
		<path class="st0" d="M0,14h40v-2H0V14z"/>
		<path class="st0" d="M40,26H0v-2h40V26z"/>
		<path class="st0" d="M0,8h11V6H0V8z"/>
		<path class="st0" d="M40,32H29v-2h11V32z"/>
		<path class="st0" d="M19,8h21V6H19V8z"/>
		<path class="st0" d="M21,32H0v-2h21V32z"/>
		<path class="st0" d="M14,8h2V6h-2V8z"/>
		<path class="st0" d="M26,32h-2v-2h2V32z"/>
		<path class="st0" d="M38,2h2V0h-2V2z"/>
		<path class="st0" d="M2,38H0v-2h2V38z"/>
		<path class="st0" d="M38,20h2v-2h-2V20z"/>
		<path class="st0" d="M21,20h-2v-2h2V20z"/>
		<path class="st0" d="M0,20h2v-2H0V20z"/>
		<path class="st0" d="M16,20H5v-2h11V20z"/>
		<path class="st0" d="M24,20h11v-2H24V20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Code
};
